import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { modalAlert } from "../../_actions";
import { Row, Col, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from "react-bootstrap";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import FontAwesome from "react-fontawesome";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import "../NoteActionPageCommon/index.css";
import "./index.css";

class NoteRetractResolvePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      waitingForResponse: false,
      comment: "",
      note: null,
      redirect: null
    };
  }

  componentDidMount = () => {
    if (this.props.match.params !== null && this.props.configList) {
      const noteID = this.props.match.params.noteID;
      this.getNote(noteID);
    }
  };

  componentWillReceiveProps = nextProps => {
    if (JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList)) {
      if (this.props.match.params !== null) {
        const noteID = this.props.match.params.noteID;
        this.getNote(noteID);
      }
    }
  };

  getNote = id => {
    const url = "/api/v1/notes/" + id + "/";
    const errorMsg = "Unable to get the current note details.";
    api.getFetch(url, "", this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return { note: json };
      });
    });
  };

  onChange = e => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(() => {
      return { state };
    });
  };

  submitForm = () => {
    this.setState(() => {
      return { validated: true };
    });

    if (this.state.comment !== null && this.state.comment.length > 0) {
      this.submitAction();
    }
  };

  submitAction = () => {
    const url = "/api/v1/notes/" + this.state.note.id + "/retract_resolve/";
    const errorMsg = "Unable to retract resolution for this note.";

    this.setState(() => {
      return { waitingForResponse: true };
    });

    const payload = {
      comment: this.state.comment
    };

    api.postFetch(url, payload, this.props.user.token, errorMsg, true).then(json => {
      this.setState(() => {
        return { waitingForResponse: false };
      });

      if (json.success) {
        this.setState({ redirect: "/note/" + this.state.note.id + "/view" });
      }
    });
  };

  renderTitlePanel = () => {
    return (
      <div>
        <div className="mainTitle">
          <div className="breadCrumb">
            <Link to={"/note/" + this.state.note.id + "/view"}>
              <FontAwesome name="arrow-left" size="lg" /> Back to Note
            </Link>
          </div>
          <h1>Retract Note Resolution: {this.state.note.title + " (ID: " + this.state.note.id + ")"}</h1>
        </div>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  renderFormButtons = () => {
    if (this.state.waitingForResponse) {
      return <div className="submitted-message">Retracting note resolution...</div>;
    } else {
      return (
        <div className="form-action-buttons">
          <Link to={"/note/" + this.state.note.id + "/view"} className="btn btn-default">
            Cancel
          </Link>
          <Button bsStyle="primary" onClick={this.submitForm}>
            Retract Resolution
          </Button>
        </div>
      );
    }
  };

  renderWorkflow = () => {
    return (
      <div className="workflow-track">
        <div className="workflow-track-state">Open</div>
        <div className="workflow-track-state-transition">
          <span className="workflow-transition-direction-left">↑</span>
          Retract Resolution
          <span className="workflow-transition-direction-right">↑</span>
        </div>
        <div className="workflow-track-state workflow-track-state-active">Resolved</div>
        <div className="workflow-track-state">Signed Off</div>
      </div>
    );
  };

  renderForm = () => {
    return (
      <form>
        <FormGroup validationState={this.state.validated && !this.state.comment ? "error" : null}>
          <ControlLabel>Comment</ControlLabel>
          <FormControl
            componentClass="textarea"
            placeholder="Add a comment to explain why the resolution is being retracted"
            name="comment"
            value={this.state.comment}
            onChange={this.onChange}
          />
          {this.state.validated && !this.state.comment ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Please enter a comment.
              </HelpBlock>
            </div>
          ) : null}
        </FormGroup>

        {this.renderFormButtons()}
      </form>
    );
  };

  renderMessage = () => {
    return (
      <p>
        You are about to retract the resolution for this note and return it to an open status. To do so, please add a
        comment to the text box below describing why the resolution needs to be retracted, then click "Retract
        Resolution".
      </p>
    );
  };

  renderMainContent = () => {
    if (!this.state.note.resolution_can_be_retracted) {
      return (
        <div className="panel-div">
          <p>Resolution for this note cannot be retracted at this time.</p>
        </div>
      );
    }
    return (
      <Row>
        <Col md={3} xs={12} className="hidden-sm hidden-xs">
          {this.renderWorkflow()}
        </Col>
        <Col md={9} xs={12}>
          <div className="panel-div">{this.renderMessage()}</div>
          <div className="panel-div">{this.renderForm()}</div>
        </Col>
      </Row>
    );
  };

  render = () => {
    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }

    if (this.state.note === null) {
      return <div>{this.renderLoadingPage()}</div>;
    }

    return (
      <div className="viewNotePage">
        <MenuBar />
        <FilterMenuBar />
        <div className="mainPanelCon">
          <div className="container">
            {this.renderTitlePanel()}

            <div className="mainContent">{this.renderMainContent()}</div>
          </div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    user,
    configList
  };
}

export default connect(mapStateToProps, {
  modalAlert
})(NoteRetractResolvePage);



// WEBPACK FOOTER //
// ./src/_components/NoteRetractResolvePage/index.js